import useCurrentLang from '@shared/hooks/useCurrentLang';
import { getLangTextValue } from '@shared/util/textGetters';

export function LngText({
    record,
}: {
    record: Record<string, string> | string | null;
}) {
    const locale = useCurrentLang();

    return <span>{getLangTextValue(record ?? undefined, locale)}</span>;
}
